import * as React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import styles from "./ShortenedText.module.scss";

interface ShortenedTextProps {
    notes?: string;
    identifyingKey: string;
    maxLength?: number;
    className?: string;
}

export const ShortenedText: React.FC<ShortenedTextProps> = ({
    notes = "",
    identifyingKey,
    maxLength = 10,
    className,
}) => {
    const text = notes || "";

    if (text.length <= maxLength) {
        return (
            <p className={`${styles.preserveLineBreaks} ${className || ""}`}>
                {text}
            </p>
        );
    }

    // Find the last space before maxLength to avoid cutting words
    let truncateAt = maxLength;
    const lastSpaceIndex = text.lastIndexOf(" ", maxLength);
    if (lastSpaceIndex > maxLength * 0.7) {
        // Only use last space if it is not too far back
        truncateAt = lastSpaceIndex;
    }

    const truncatedText = text.substring(0, truncateAt);

    return (
        <div>
            <span className={styles.srOnly}>{text}</span>
            <OverlayTrigger
                delay={{ show: 250, hide: 400 }}
                placement="bottom"
                overlay={
                    <Tooltip id={`tooltip-${identifyingKey}`}>
                        <span className={styles.preserveLineBreaks}>{text}</span>
                    </Tooltip>
                }
            >
                <p
                    className={`${styles.notes} ${styles.preserveLineBreaks} ${
                        className || ""
                    }`}
                >{`${truncatedText}.....`}</p>
            </OverlayTrigger>{" "}
        </div>
    );
};

export default ShortenedText;
